<template>
  <div>
    <Collapse v-model="value" simple style="border: 0">
      <Panel name="1" hide-arrow style="margin: 20px 0; border: 0">
        <FormTitle
          :titleText="$t('Performance_Improvement_Plan')"
        /><!-- 绩效改进计划 -->
        <div slot="content" style="margin-top: 20px">
          <div>
            <!-- PIP起止日期及回顾频率 -->{{
              $t("PIP_Duration_and_Review_Frequency_")
            }}
          </div>
          <Divider />
          <Form
            :label-width="100"
            label-position="left"
            slot="content"
            style="margin: 30px 5px 0 5px"
            :disabled="isDirSup == '2' || isDirSup == '3' || item.status >= 1"
          >
            <Row :gutter="40">
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Start_Date')"
                  ><!-- 开始日期 -->
                  <DatePicker
                    v-model="formItem.startDate"
                    :transfer="true"
                    type="date"
                  ></DatePicker>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('End_Date')"
                  ><!-- 结束日期 -->
                  <DatePicker
                    v-model="formItem.endDate"
                    :transfer="true"
                    type="date"
                  ></DatePicker>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Review_Frequency_')"
                  ><!-- 回顾频率 -->
                  <Select v-model="formItem.reviewRate">
                    <Option
                      v-for="item in ReviewFrequency"
                      :value="item.code"
                      :key="item.code"
                      >{{
                        lang == "zh" ? item.ch_value : item.en_value
                      }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
            </Row>
          </Form>
          <div class="panelTit">
            <!-- 绩效表现情况陈述 -->{{
              $t("Statement_of_Performance_Issues_")
            }}
          </div>
          <Divider />
          <!-- <div>说明绩效表现的问题，影响和所需改善的方面</div>
                    <ul style="margin-left:16px;margin-bottom:20px">
                        <li>绩效表现具体在哪些方面没有达到岗位要求？</li>
                        <li>举出具体例子：如具体事件，项目，没有在指定日期前完成工作，没有完成工作量等</li>
                        <li>参考制定绩效改进计划之前曾提供给该员工的指导，讨论，辅导，建议等</li>
                    </ul> -->
          <div>{{ $t("longText15") }}</div>
          <Input
            v-model="formItem.achDetails"
            type="textarea"
            :rows="4"
            :disabled="isDirSup == '2' || isDirSup == '3' || item.status >= 1"
          />

          <div class="panelTit">
            <!-- 要求的绩效标准 -->{{ $t("longText16") }}
          </div>
          <Divider />
          <!-- <div>请写出期望员工达到的绩效标准，以此帮助员工建立明确的发展方向。相关要求应遵循SMART原则</div>
                    <div style="margin-bottom:20px">(S:具体化, M:可衡量的, A:可达到的, R:相关性, T:时限性)</div> -->
          <div style="margin-bottom: 20px">{{ $t("longText17") }}</div>
          <Input
            v-model="formItem.achStandard"
            type="textarea"
            :rows="4"
            :disabled="isDirSup == '2' || isDirSup == '3' || item.status >= 1"
          />

          <div class="panelTit">
            <!-- 提高绩效的行动 -->{{ $t("longText18") }}
          </div>
          <Divider />
          <div style="margin-bottom: 20px">
            {{ $t("longText19")
            }}<!-- 列出已达成共识的行动（含培训/辅导/转岗等安排），这将帮助员工提高绩效并达到要求的绩效标准。描述这些行动时，应尽量具体化。在每次正式的绩效改进沟通会后，请更新每个行动的最新状态。 -->
          </div>
          <Table border :columns="columns5" :data="data5">
            <template slot-scope="{ row, index }" slot="action">
              <Input
                type="textarea"
                v-model="row.action"
                :autosize="true"
                :disabled="
                  isDirSup == '2' || isDirSup == '3' || item.status >= 1
                "
                @on-change="targetItemChange(row, index, 'action')"
              />
            </template>
            <template
              slot-scope="{ row, index }"
              slot="finishDate"
              style="width: 100%"
            >
              <DatePicker
                type="date"
                v-model="row.finishDate"
                :transfer="true"
                :disabled="
                  isDirSup == '2' || isDirSup == '3' || item.status >= 1
                "
                :clearable="false"
                @on-change="targetItemChange(row, index, 'finishDate')"
              />
            </template>
            <template
              slot-scope="{ row, index }"
              slot="dutyUser"
              style="width: 100%"
            >
              <Input
                type="textarea"
                v-model="row.dutyUser"
                :autosize="true"
                :disabled="
                  isDirSup == '2' || isDirSup == '3' || item.status >= 1
                "
                @on-change="targetItemChange(row, index, 'dutyUser')"
              />
            </template>
            <template slot-scope="{ row, index }" slot="startDate">
              <Input
                type="textarea"
                v-model="row.activesPerformed"
                :autosize="true"
                :disabled="
                  isDirSup == '2' || isDirSup == '3' || item.status >= 1
                "
                @on-change="targetItemChange(row, index, 'activesPerformed')"
              />
            </template>
            <template slot-scope="{ row, index }" slot="measureFun">
              <Input
                type="textarea"
                v-model="row.measureFun"
                :autosize="true"
                :disabled="
                  isDirSup == '2' || isDirSup == '3' || item.status >= 1
                "
                @on-change="targetItemChange(row, index, 'measureFun')"
              />
            </template>
            <template slot-scope="{ row, index }" slot="finishResult">
              <Input
                type="textarea"
                v-model="row.finishResult"
                :autosize="true"
                :disabled="
                  isDirSup == '2' || isDirSup == '3' || item.status >= 1
                "
                @on-change="targetItemChange(row, index, 'finishResult')"
              />
            </template>
            <template slot-scope="{ row, index }" slot="action5">
              <Button
                icon="md-trash"
                type="warning"
                size="small"
                :disabled="
                  isDirSup == '2' || isDirSup == '3' || item.status >= 1
                "
                @click="deletePlan(index, row)"
              ></Button>
            </template>
          </Table>
          <div
            style="
              display: flex;
              justify-content: flex-end;
              margin-top: 10px;
              margin-bottom: 30px;
            "
          >
            <Button
              @click="addPlan()"
              :disabled="isDirSup == '2' || isDirSup == '3' || item.status >= 1"
              ><!-- 新增 -->{{ $t("Add") }}</Button
            >
          </div>

          <Alert type="error"
            >{{ $t("longText20")
            }}<!-- 注：员工知悉并同意，如绩效改善未达到上表所列全部要求的，将导致警告/降薪/降级/调离目前职位或解除劳动合同等后果。 --></Alert
          >

          <Checkbox
            style="margin-top: 30px"
            :disabled="isDirSup != '2' || (isDirSup == '2' && item.status >= 2)"
            v-model="formItem.beAgreeOn"
          >
            <span style="font-weight: bold">
              {{ $t("longText52") }}</span
            ></Checkbox
          >
        </div>
      </Panel>
    </Collapse>
    <div class="btnRight" style="padding-top: 0px">
      <Button
        type="primary"
        class="applyBtnRight"
        @click="submit"
        v-if="
          (isDirSup == '2' && item.status == 1) ||
          (isDirSup == '1' && item.status == '') ||
          (isDirSup == '1' && !id)
        "
        ><!-- 提交 -->{{ $t("Submit") }}</Button
      >
      <Button type="primary" class="applyBtnRight" @click="returnApply"
        ><!-- 返回 -->{{ $t("Return") }}</Button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "@/util/DateUtil";
export default {
  data() {
    return {
      date: new DateUtil(),
      value: [1],
      formItem: {},
      list: [{ value: 0, label: "name1" }],
      textareaValue1: "",
      textareaValue2: "",
      single: "",
      data5: [],
      isDirSup: "",
      id: "",
      item: {},
      ReviewFrequency: [],
    };
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    columns5() {
      return [
        {
          title: this.$t("Actions") /* 行动 */,
          slot: "action",
          align: "center",
          minWidth: 300,
        },
        {
          title: this.$t("Deadlines") /* 完成时间 */,
          slot: "finishDate",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Responsibles") /* 责任人 */,
          slot: "dutyUser",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Measurement") /* 衡量方法 */,
          slot: "measureFun",
          align: "center",
          minWidth: 300,
        },
        {
          title: this.$t("Result") /* 完成结果 */,
          slot: "finishResult",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Action") /* 操作 */,
          slot: "action5",
          align: "center",
          minWidth: 100,
        },
      ];
    },
    lang() {
      return this.$store.getters.selectLangeData;
    },
  },
  created() {
    if (!this.$route.query.toPage) {
      let item = JSON.parse(this.$route.query.item);
      if (item.code == "ESS") {
        document.title = "新增绩效改进";
      } else {
        document.title = item.userName + "的绩效改进";
      }
    }
    this.getListData();
  },
  methods: {
    getData(item) {
      this.item = item;
      let obj = {
        id: this.id,
        stage: "改进计划",
        serialnumber: item.serialnumber,
        year: item.year,
      };
      axios.post("/achUpdatePlan/selectAchUpdatePlanInfo", obj).then((res) => {
        if (res) {
          res.achRaiseActionList ? (this.data5 = res.achRaiseActionList) : "";
          this.formItem = res;
          this.formItem.startDate = this.date.dateVal(
            this.formItem.startDate,
            "YYYY-MM-DD"
          );
          this.formItem.endDate = this.date.dateVal(
            this.formItem.endDate,
            "YYYY-MM-DD"
          );
          this.formItem.beAgreeOn = !!+this.formItem.beAgreeOn;
          this.item = this.formItem;
        }
      });
    },
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then((res) => {
        if (res) {
          this.ReviewFrequency = res.ReviewFrequency;
        }
      });
    },
    deletePlan(index, row) {
      this.$Modal.confirm({
        title: this.$t("Are_you_sure_to_delete"),
        onOk: () => {
          this.data5.splice(index, 1);
        },
      });
    },
    addPlan() {
      this.data5.push({
        action: "",
        dinishDate: "",
        dutyUser: "",
        measureFun: "",
        finishResult: "",
      });
    },
    targetItemChange(row, index, key) {
      key && this.$set(this.data5[index], key, row[`${key}`]);
    },
    submit() {
      if (
        this.empCheck() &&
        (this.formItem.beAgreeOn == "" || !this.formItem.beAgreeOn)
      ) {
        this.$Message.info(
          this.$t(
            "请勾选本人与直线经理就我的工作表现进行了讨论并制定了上述的行动计划，双方已达成共识。"
          )
        );
        return;
      }
      if (this.dirCheck() && !this.item.serialnumber) {
        this.$Message.info(this.$t("请选择员工"));
        return;
      }
      this.formItem.startDate = this.date.dateVal(
        this.formItem.startDate,
        "YYYY-MM-DD"
      );
      this.formItem.endDate = this.date.dateVal(
        this.formItem.endDate,
        "YYYY-MM-DD"
      );

      let json = JSON.parse(JSON.stringify(this.formItem));
      json.beAgreeOn ? (json.beAgreeOn = "1") : (json.beAgreeOn = "0");
      let json1 = JSON.parse(JSON.stringify(this.item));
      json1.beAgreeOn ? (json1.beAgreeOn = "1") : (json1.beAgreeOn = "0");
      this.$Modal.confirm({
        title: this.$t("Please_confirm_whether_to_submit"),
        onOk: () => {
          let obj = {
            id: this.id,
            stage: "改进计划",
            achRaiseActionList: this.data5,
            ...json,
            ...json1,
          };
          axios
            .post("/achUpdatePlan/insertAchUpdatePlanInfo", obj)
            .then((res) => {
              this.id = res;
              this.$Message.success(this.$t("sbumit_Success"));
              this.getData(this.item);
            });
        },
      });
    },
    returnApply() {
      if (this.$route.query.toPage == "staffview") {
        this.$router.back();
      } else {
        this.$router.push({
          path: "/A8E9DCF043CE767F05D716BD894E6E2DA1F5FE9AF7628B41/A3FFBEBFDB713E27",
          query: { name: "PerformanceCoaching" },
        });
      }

      // this.$router.back()
    },
    empCheck() {
      if (
        this.isDirSup != "2" ||
        (this.isDirSup == "2" && this.item.status >= 2)
      ) {
        return false;
      } else {
        return true;
      }
    },
    dirCheck() {
      if (
        this.isDirSup == "2" ||
        this.isDirSup == "3" ||
        this.item.status >= 1
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.panelTit {
  margin-top: 30px;
}
/deep/.ivu-divider-horizontal {
  margin: 10px 0 24px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/MyAchievementsComponents/ImprovementPlan.vue